export const EI_TABLE_TEXT = {
    globalSearchPlaceholder: 'Search',
    manageColumnsLabel: 'Columns',
    manageColumnsPlaceholder: 'Manage columns',
    noResults: 'No results',
    noData: 'No data',
    prev: 'Prev',
    next: 'Next',
    pageSizeLabel: 'Show',
    pageSizeSuffix: 'per page',
    showing: 'Showing',
    to: 'to',
    of: 'of',
    entries: 'entries',
    items: 'items',
    recordsFound: 'records found',
    columnSearchPlaceholder: 'Search...',
    selectAllRowsAriaLabel: 'Select all rows',
    selectRowAriaLabel: 'Select row',
    filterAriaLabelPrefix: 'Filter ',
    saveAriaLabel: 'Save',
    cancelAriaLabel: 'Cancel',
} as const

export const EI_TABLE_DEFAULTS = {
    pageSize: 10,
    pageSizeOptions: [10, 25, 50] as const,
    viewId: 'ei-table',
    rowIdKey: 'id',
    actionsColumnKey: 'actions',
} as const

/**
 * UI dimension constants for table columns
 */
export const EI_TABLE_DIMENSIONS = {
    checkboxColumnWidth: 52,
    rowNumberColumnWidth: 60,
    mobileBreakpoint: 768,
    minColumnWidth: 150,
    editColumnMinWidth: 280,
} as const

/**
 * Ellipsis page number markers for pagination
 */
export const EI_TABLE_PAGINATION = {
    ellipsisStart: -1,
    ellipsisEnd: -2,
    maxVisiblePages: 7,
    pageOffset: 1, // Used for calculating visible page range
} as const

export const sortIcon = {
    asc: 'arrow_upward',
    desc: 'arrow_downward',
    default: 'unfold_more',
}
